import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";

/** Handles the #session_id=... hash returned by Emergent's Google auth. */
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    const exchange = async () => {
      try {
        const apiBase = `${process.env.REACT_APP_BACKEND_URL}/api`;
        const r = await axios.post(
          `${apiBase}/auth/session`,
          {},
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          },
        );
        toast.success(`Welcome, ${r.data.name || "Heather"}.`);
        // Clean the hash and route to admin
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail || "Sign-in failed";
        setError(typeof detail === "string" ? detail : "Sign-in failed");
      }
    };
    exchange();
  }, [navigate]);

  if (error) {
    return (
      <div className="max-w-md mx-auto p-12 text-center">
        <h1 className="font-heading text-2xl text-[var(--gg-error)]">{error}</h1>
        <p className="text-sm text-gg-muted mt-3">
          This admin is restricted to a single allowed Google account.
        </p>
        <button
          type="button"
          onClick={() => navigate("/admin/login", { replace: true })}
          className="btn-pill btn-outline mt-6 inline-flex"
        >
          Back to sign-in
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-12 text-center">
      <p className="font-script text-3xl text-gg-green">just a moment</p>
      <h1 className="font-heading text-2xl mt-2">Signing you in…</h1>
    </div>
  );
}
